module.exports = __webpack_public_path__ + "img/background-1.79ecd615.jpg";